// # types
// this file is used to set the redux actions

const types = {
    "EXAMPLE": "EXAMPLE",

    // Messages
    "ADD_TO_SEND":          "ADD_TO_SEND",
    "REMOVE_FIRST_TO_SEND": "REMOVE_FIRST_TO_SEND",

    // User types.
    "ADD_USERNAME":        "ADD_USERNAME",
    "REMOVE_USERNAME":     "REMOVE_USERNAME",
    "RESET_USER":          "RESET_USER",
    "SET_USERNAME_STATUS": "SET_USERNAME_STATUS",

    // User made.
    "ADD_ART":             "ADD_ART",
    "ADD_CAPTION":         "ADD_CAPTION",
    "ADD_COMBO":           "ADD_COMBO",
    "ADD_VOTE":            "ADD_VOTE",
    "RESET_USER_MADE":     "RESET_USER_MADE",
    

    // Tasks.
    "TASK_SET_GROUP": "TASK_SET_GROUP",

    // Groups.
    "GROUPS_SET_GROUP": "GROUPS_SET_GROUP",

    // Requirements.
    "REQUIREMENTS_SET": "REQUIREMENTS_SET",

    "RESOURCES_SET": "RESOURCES_SET",

    "SET_LOGIN": "SET_LOGIN",
};

export default types;